import React from 'react';
import moment from 'moment';
import { shortDate, fullDate, monthNameFormatDate } from '../../../core/date';

class TourDates extends React.Component {

  render() {
    const start = moment(this.props.start);
    if (!start.isValid()) {
      return (
        <span>
              -
        </span>);
    }
    return (
      <span>
        { monthNameFormatDate(this.props.start) } - { monthNameFormatDate(this.props.end)}
      </span>

    );
  }
}
export default TourDates;



// WEBPACK FOOTER //
// src/routes/booking/components/TourDates.js